import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

const WidgetUtilityWrapper = styled.div<{ marginBottom: string }>`
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;

export const CalendarIconWrapper = styled.span`
    display: inline-block;
    width: 14px;
    padding-right: 10px;
    height: 14px;
    position: relative;
    top: 2px;
`;

export const StyledSubTitle = styled.span`
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
    font-style: normal;
`;

export const StyledTitle = styled.span`
    ${setFontVariant("caption", colorsPalettes.carbon[300])}
    font-style: normal;
    line-height: 10px;
`;

export const StyledTitleWrapper = styled.span`
    display: flex;
    justify-content: center;
    flex-direction: column;
`;
